import { PartnerBaseInterface } from "@/types/partner.types";
import { API_ROUTES } from "../apiRoutes";
import { REQUEST_METHODS } from "../configs.apiClient";
import { HttpClient } from "../HttpClient";

export class PartnerAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async fetchCouponDetails({
    planId,
    couponCode,
  }: {
    planId?: string;
    couponCode?: string;
  }) {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.partner.partnerCouponDetails;

      let queryParams = {
        planId: planId ?? "",
        couponCode: couponCode ?? "",
      };

      const response = await this.httpClient.request<PartnerBaseInterface>({
        endpoint,
        options: {
          method,
        },
        queryParams,
      });

      return response?.data;
    } catch (error) {
      console.error("Error in PartnerAPIClient fetchCouponDetails", error);
    }
  }
}
